import Header from "../common/Header";
import Container from "../common/Container";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { deletePost } from "../redux/posts";

export default function Detail() {
  const { id } = useParams();
  const navigate = useNavigate();
  // @ts-ignore
  const posts = useSelector((state) => state.posts);
  // @ts-ignore
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const post = posts.find((post) => post.id === id);

  const isLoggedIn = () => {
    if (!user.email) return false;
    return true;
  };

  const isSameUser = (author) => {
    if (user.email !== author) return false;
    return true;
  };
  return (
    <>
      <Header />
      <Container>
        <h1
          style={{
            border: "1px solid lightgray",
            borderRadius: "12px",
            padding: "12px",
          }}
        >
          {post?.title}
        </h1>
        <div
          style={{
            height: "400px",
            border: "1px solid lightgray",
            borderRadius: "12px",
            padding: "12px",
          }}
        >
          {post?.content}
        </div>
        <div
          style={{
            marginTop: "12px",
            display: "flex",
            justifyContent: "end",
          }}
        >
          <button
            onClick={() => {
              if (!isLoggedIn()) {
                return alert("로그인 후 사용할 수 있습니다.");
              }
              if (!isSameUser(post.author)) {
                return alert("작성자가 일치하지 않습니다.");
              }
              navigate("/edit", {
                state: {
                  post,
                },
              });
            }}
            style={{
              border: "none",
              padding: "8px",
              borderRadius: "6px",
              backgroundColor: "orange",
              color: "white",
              cursor: "pointer",
              marginRight: "6px",
            }}
          >
            수정
          </button>
          <button
            onClick={() => {
              if (!isLoggedIn()) {
                return alert("로그인 후 사용할 수 있습니다.");
              }
              if (!isSameUser(post.author)) {
                return alert("작성자가 일치하지 않습니다.");
              }
              const result = window.confirm("정말로 삭제하시겠습니까?");
              if (result) {
                dispatch(deletePost(post.id));
                navigate("/");
              }
            }}
            style={{
              border: "none",
              padding: "8px",
              borderRadius: "6px",
              backgroundColor: "red",
              color: "white",
              cursor: "pointer",
            }}
          >
            삭제
          </button>
        </div>
      </Container>
    </>
  );
}
